import React from "react";
import { useACL } from "layouts/agent/agent-info/agent-acl/_context/AgentACLContext";
import ACLSelect from "../../components/ACLSelect";
import { ACLEntryPermission, ACLPayload } from "types";
import api from "api/axios";
import { useAgentInfo } from "layouts/agent/agent-info/_context/AgentInfoContext";
import { handleAxiosAndCaughtError } from "utils";
import { useTranslation } from "react-i18next";

const RoleACLEdit = ({
  permission,
  id,
}: {
  permission: ACLEntryPermission[] | null;
  id: string;
}) => {
  const { t } = useTranslation();
  const { agentInfo } = useAgentInfo();
  const { permissions, refetch } = useACL();
  const [aclEntries, setAclEntries] = React.useState<ACLEntryPermission[]>(
    permission ||
      permissions.map((perm) => ({ permission: perm, access: "NOT_SET" }))
  );
  const [isLoading, setIsLoading] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const payload: ACLPayload = {
        subject_type: "ROLE",
        subject_id: id,
        entries: aclEntries,
      };
      await api.put(`/agents/${agentInfo.id}/acl`, payload);
      await refetch();
    } catch (err) {
      console.error("Error saving permissions:", err);

      handleAxiosAndCaughtError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="md:w-[50vh]">
      <div className="flex flex-col gap-2">
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {t("agents.acl.setPermissions")}
        </label>
        <ACLSelect
          permissions={permissions}
          value={aclEntries}
          onChange={setAclEntries}
          loading={isLoading}
        />
      </div>

      <div className="flex flex-col gap-3 pt-6 sm:flex-row sm:gap-4">
        <button
          type="submit"
          className="flex-1 rounded-lg bg-brand-500 px-3 py-1.5 text-sm font-semibold text-white transition-colors hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-opacity-20 disabled:cursor-not-allowed disabled:opacity-50"
          disabled={isLoading}
        >
          {isLoading ? (
            <div className="flex items-center justify-center gap-1.5">
              <div className="border-t-transparent h-3 w-3 animate-spin rounded-full border-2 border-white"></div>
              <span className="text-sm">{t("agents.acl.saving")}</span>
            </div>
          ) : (
            t("agents.acl.saveChanges")
          )}
        </button>
      </div>
    </form>
  );
};

export default RoleACLEdit;